import { useStateSelector } from '../../data/global/dataSelectors';
import { getReleaseNotesFilterData } from '../../data/global/selectors/infoSelectors';

export const useReleaseNotesData = () => {
  const ui = useStateSelector(getReleaseNotesFilterData);
  const { page, pageSize } = ui;

  return { page, pageSize };
};
